
import React from "react";
import LegalLayout from "@/components/layout/LegalLayout";
import { Shield } from "lucide-react";

const PrivacyPolicy = () => {
  return (
    <LegalLayout 
      title="Privacy Policy" 
      icon={<Shield className="h-5 w-5 text-primary" />}
      lastUpdated="July 22, 2025"
    >
      <div className="space-y-4 text-sm text-slate-700 mb-6 p-4 bg-slate-50 rounded-lg">
        <p><strong>Effective Date:</strong> July 22, 2025</p>
        <p><strong>Company:</strong> Timesy B.V.</p>
        <p><strong>Address:</strong> Raamplein 1, 1016 XK Amsterdam, Netherlands</p>
        <p><strong>KVK Number:</strong> 82843554</p>
        <p><strong>Phone:</strong> +31 6 17422916</p>
        <p><strong>Email:</strong> privacy@snaprefund.com</p>
      </div>

      <h2>1. Introduction</h2>
      <p>
        At SnapRefund, your privacy is important to us. This Privacy Policy explains how we collect, use, store, and protect your personal data in accordance with the General Data Protection Regulation (GDPR) and applicable Dutch laws.
      </p>
      
      <h2>2. What Data We Collect</h2>
      <p>We may collect the following types of personal data:</p>
      <ul>
        <li>Contact details (name, email, phone number)</li>
        <li>Account information</li>
        <li>Payment and transaction details</li>
        <li>IP address, device and browser information</li>
        <li>Content of communications with customer support</li>
        <li>Any data you submit related to refund requests</li>
      </ul>
      
      <h2>3. How We Use Your Data</h2>
      <p>We use your data to:</p>
      <ul>
        <li>Provide and operate our services</li>
        <li>Communicate with you</li>
        <li>Process payments and refunds</li>
        <li>Improve our platform and user experience</li>
        <li>Comply with legal obligations</li>
      </ul>
      
      <h2>4. Legal Basis</h2>
      <p>We process your data based on:</p>
      <ul>
        <li>Your consent</li>
        <li>Contractual necessity</li>
        <li>Legal obligations</li>
        <li>Our legitimate interest in operating SnapRefund</li>
      </ul>
      
      <h2>5. Data Retention</h2>
      <p>
        We retain your data only as long as necessary for the purposes for which it was collected or to comply with legal obligations.
      </p>
      
      <h2>6. Sharing Your Data</h2>
      <p>We may share your data with:</p>
      <ul>
        <li>Payment processors</li>
        <li>Hosting and analytics providers</li>
        <li>Legal or regulatory authorities when required</li>
      </ul>
      <p>We never sell your personal data.</p>
      
      <h2>7. Your Rights</h2>
      <p>Under the GDPR, you have the right to:</p>
      <ul>
        <li>Access your data</li>
        <li>Correct inaccurate data</li>
        <li>Erase your data ("right to be forgotten")</li>
        <li>Restrict or object to processing</li>
        <li>Data portability</li>
        <li>Withdraw consent</li>
      </ul>
      <p>To exercise your rights, contact us at: privacy@snaprefund.com</p>
      
      <h2>8. Security</h2>
      <p>
        We use industry-standard technical and organizational measures to protect your data.
      </p>
      
      <h2>9. Changes</h2>
      <p>
        We may update this policy from time to time. We'll notify you of significant changes by email or in-app notice.
      </p>
    </LegalLayout>
  );
};

export default PrivacyPolicy;
